import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHierarchy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11 7C11.5523 7 12 7.44772 12 8V10H14L14.1025 10.0049C14.6067 10.0562 15 10.4823 15 11V14C15 14.5177 14.6067 14.9438 14.1025 14.9951L14 15H10C9.48232 15 9.05621 14.6067 9.00488 14.1025L9 14V11C9 10.4477 9.44772 10 10 10H11V8H5V10H6L6.10254 10.0049C6.60667 10.0562 7 10.4823 7 11V14C7 14.5177 6.60667 14.9438 6.10254 14.9951L6 15H2C1.48232 15 1.05621 14.6067 1.00488 14.1025L1 14V11C1 10.4477 1.44772 10 2 10H4V8C4 7.44778 4.4478 7.0001 5 7H11ZM2 14H6V11H2V14ZM10 14H14V11H10V14Z",
		fill: "#000000"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.1025 1.00488C10.6067 1.05621 11 1.48232 11 2V5C11 5.51768 10.6067 5.94379 10.1025 5.99512L10 6H6C5.48232 6 5.05621 5.60667 5.00488 5.10254L5 5V2C5 1.44772 5.44772 1 6 1H10L10.1025 1.00488ZM6 5H10V2H6V5Z",
		fill: "#000000"
	})]
});
export default SvgHierarchy;
